import styled from 'styled-components';
import { Chip } from 'react-rainbow-components';

export const Container = styled.div<{ align: string }>`
    display: flex;
    justify-content: ${(props) => props.align};
    align-content: center;
    align-items: center;
    padding: 0.25rem 0.5rem;
    flex-wrap: wrap;
    gap: 0.5rem;
`;

export const Tag = styled(Chip)`
    font-size: 0.75rem;
    font-weight: 400;
    height: 1.25rem;
    padding: 0.125rem 0.5rem;
    border-radius: 0.375rem;
    background: #f3f4f6;
    color: #6b7280;
    border: 1px solid #e5e7eb;
    transition: background-color 0.15s ease;
    cursor: default;
    
    &:hover {
        background: #e5e7eb;
    }
    
    & > span {
        text-transform: none;
        line-height: 1;
    }
`;
